import { mountVueWithPinia } from '../vue/mountVue';
import App from '../vue/Collection/App.vue';

export class CommercialCollection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.scrollTo(0, 0);
    console.log('Commercial Collection Loaded');
    mountVueWithPinia('.js-commercial-collection', App, this);
  }
}

customElements.define('commercial-collection', CommercialCollection);
